import React from 'react'

import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { appUpdateRequest } from '../../actions'
import { Prompt } from 'react-router-dom'

import { Box, Row, Column } from 'components/Layout'
import { Image } from 'components/Image'
import { Form, FormSection, FormError } from 'components/Form'
import { SaveButton } from 'components/Button'
import { BoxShell } from 'components/Shells'

import { webhookUrlValidator } from './validators.js'
import FieldSection from './FieldSection.js'
import { TEXT } from './fieldTypes.js'

import installationWebhook from '../../assets/intros/girl-webhooks.png'

const AppFeaturesWebhooksForm = props => {
	const {
		dispatchSubmit,
		handleSubmit,
		submitting,
		dirty,
		app,
		error,
		readOnly,
		inReview
	} = props

	const fields = [
		{
			type: TEXT,
			name: 'webhookUrl',
			fieldId: 'webhookUrl',
			title: 'App Webhook URL',
			description:
				'An URL to your backend, which will process webhook information. We currently send webhooks for both installation and uninstallation of the app.',
			placeholder: 'https://www.yourbackend.com/',
			validate: webhookUrlValidator,
			required: true,
			disabled: readOnly || inReview
		}
	]
	if (typeof app === 'undefined') {
		return (
			<Form>
				<BoxShell height={200} />
				<BoxShell height={140} />
			</Form>
		)
	}

	return (
		<Form handleSubmit={handleSubmit(dispatchSubmit)}>
			<Prompt
				when={submitting || dirty}
				message={() =>
					`You've got unsaved changes. Are you sure you want to leave this page?`
				}
			/>

			<Box
				header={'App Webhooks'}
				body={
					<span>
						<FormSection dark>
							<Row notPadded center>
								<Column width={3}>
									{
										<Image
											src={installationWebhook}
											width={175}
										/>
									}
								</Column>
								<Column>
									<p>
										With <strong>App Webhooks</strong> you
										can monitor your app installations.
										We'll send you the information every
										time a user installs or deinstalls the
										app.
									</p>
								</Column>
							</Row>
						</FormSection>
						<div>
							{fields.map(field => {
								return (
									<FieldSection
										{...field}
										key={field.fieldId}
									/>
								)
							})}
						</div>
					</span>
				}
				info={
					!readOnly ? (
						<span>
							{!submitting ? <FormError error={error} /> : null}
							<SaveButton submitting={submitting} dirty={dirty} />
						</span>
					) : null
				}
			/>
		</Form>
	)
}

const mapStateToProps = (state, ownProps) => {
	const currentApp = state.apps.items[ownProps.match.params.appId]
	const readOnly = currentApp ? currentApp.status !== 'IN_DEVELOPMENT' : false
	const inReview = currentApp ? currentApp.status === 'IN_REVIEW' : false
	return {
		app: currentApp,
		readOnly,
		inReview,
		initialValues: currentApp || {
			customData: {}
		}
	}
}

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		dispatchSubmit: values => {
			dispatch(
				appUpdateRequest({
					formName: 'appFeaturesWebhooksForm',
					...values
				})
			)
		}
	}
}

const ConnectedAppFeaturesWebhooksForm = connect(
	mapStateToProps,
	mapDispatchToProps
)(
	reduxForm({
		form: 'appFeaturesWebhooksForm',
		touchOnBlur: false,
		enableReinitialize: true
	})(AppFeaturesWebhooksForm)
)

export default ConnectedAppFeaturesWebhooksForm



// WEBPACK FOOTER //
// ./src/containers/Forms/AppFeaturesWebhooksForm.js